<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          :caption="`LISTA DE ${roleName}`"
          icon="fas fa-coins"
          :btn_name="roleName"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="true"
          :buttonBack="false"
        />
      </CCol>
    </CRow>

    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">
          <CSelect
            label="Sede: "
            :value.sync="user.campu_id"
            :options="data_campus"
            placeholder="--Seleccione una sede--"
          />
        </CCol>
        <CCol sm="6">
          <CSelect
            label="Tipo de documento"
            :value.sync="user.document_type"
            :options="type_documents"
            placeholder="--Seleccione un documento--"
            @change="onDocumentTypeChange"
          />
        </CCol>
        <CCol sm="6">
          <CInput
            label="Número de documento"
            placeholder="Digite número de documento"
            v-model="user.dni"
            :maxlength="documentMaxLength"
            :disabled="!user.document_type"
            @keypress.enter="validateDocument"
          />
          <span v-if="errors.document" class="text-danger">{{
            errors.document
          }}</span>
        </CCol>
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            v-model="user.name"
          />
        </CCol>
        <CCol sm="12">
          <CInput
            label="Apellido"
            placeholder="Digite apellido"
            v-model="user.last_name"
          />
        </CCol>
        <CCol sm="12">
          <CInput
            label="Correo electrónico"
            placeholder="Digite correo electrónico"
            v-model="user.email"
            @input="validateEmail(user.email)"
          />
          <span v-if="errors.email" class="text-danger">{{
            errors.email
          }}</span>
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="user.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Servicio'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Nombre", _style: "width:20%;" },
  { key: "last_name", label: "Apellido", _style: "width:20%;" },
  { key: "dni", label: "Documento", _style: "width:20%;" },
  { key: "campu_name", label: "Sede", _style: "width:20%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

// import CTableWrapper from "../../../../components/shared/datatable/Table.vue";
// import CModalForm from "../../../../components/shared/modals/cModalForm.vue";
// import cModalDelete from "../../../shared/modals/cModalDelete.vue";
// import { mapActions } from "vuex";
// import CSwitchVue from "../../../shared/switch/CSwitch.vue";

import CTableWrapper from "../../../../shared/datatable/Table.vue";
import CModalForm from "../../../../../components/shared/modals/cModalForm.vue";
import cModalDelete from "../../../../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import CSwitchVue from "../../../../shared/switch/CSwitch.vue";

export default {
  components: {
    CTableWrapper,
    CModalForm,
    cModalDelete,
    CSwitchVue,
  },
  props: {
    roleId: {
      type: Number,
      required: true,
    },
    roleName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      prefix: "users",
      fields,
      data: [],
      data_campus: [],
      documentMaxLength: 8,
      type_documents: ["DNI", "PASAPORTE", "CARNET EXTRANJERÍA", "RUC"],
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      user: {
        id: "",
        rol_id: this.roleId,
        dni: "",
        name: "",
        last_name: "",
        document_type: "",
        email: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: "",
        state: 0,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      errors: {
        document: "",
        email: "",
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      documentLengths: {
        DNI: 8,
        RUC: 11,
        PASAPORTE: 15,
        "CARNET EXTRANJERÍA": 9,
      },
    };
  },
  computed: {
    cpStatus: function () {
      if (this.user.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (
        this.user.name != "" &&
        this.user.dni != "" &&
        this.user.email != "" &&
        (this.user.dni.length == 11 || this.user.last_name != "")
      )
        return false;
      return true;
    },
  },
  created() {
    this.mtd_getdata();
    this.getCampus();
  },
  watch: {
    roleId(newRoleId) {
      this.user.rol_id = newRoleId;
      this.mtd_getdata();
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtd_getdata: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/index/" +
          this.$store.getters.get_company.id +
          // "/" +
          // this.$store.getters.get_campu.id +
          "/" +
          this.roleId,
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.data = response.data;
        let index = 1;
        this.data.forEach((arr) => {
          arr.Id = arr.id;
          if (arr.campu == null) {
            arr.campu_name = "Administrador general";
          } else {
            arr.campu_name = arr.campu.name;
          }
          if (arr.state == 1) {
            arr.status = "Activo";
          } else {
            arr.status = "Inactivo";
          }
          arr.index = index;
          index++;
        });
      });
    },
    getCampus: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/bycampus/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          response.data.forEach((element) => {
            this.data_campus.push({
              label: element.name,
              value: element.id,
            });
          });
        }
      });
    },
    mtdBack: function () {
      this.mtd_getdata();
      this.$emit("mtdBack");
    },
    onDocumentTypeChange() {
      this.documentMaxLength =
        this.documentLengths[this.user.document_type] || 20;
    },
    validateDocument() {
      if (
        this.user.dni.length !== this.documentMaxLength ||
        isNaN(this.user.dni)
      ) {
        this.errors.document = `El ${this.user.document_type} debe tener ${this.documentMaxLength} dígitos y ser un número válido.`;
        return;
      }

      this.errors.document = "";

      if (this.user.dni.length === 8 || this.user.dni.length === 11) {
        this.mtdSearchDocument();
      } else if (this.user.dni.length === 9) {
        this.mtdSearchPersonByCE();
      } else {
        this.user.name = "";
        this.user.last_name = "";
        this.user.address = "";
      }
    },
    mtdSearchPersonByCE: function () {
      this.get({
        url: `${this.$store.getters.get__url}/Consultas/searchCe/${this.user.dni}`,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode !== 200) {
          Swal.fire({
            title: "Documento no encontrado",
            icon: "warning",
          });
          this.user.name = "";
          this.user.last_name = "";
          this.user.address = "";
          return;
        }

        this.user.name = response.data.client.name;
        this.user.last_name = response.data.client.last_name;
      });
    },
    mtdSearchDocument: function () {
      this.get({
        url: this.$store.getters.get__url + "/Consultas/" + this.user.dni,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.data.boo === 3) {
          this.clearPersonalData();
          Swal.fire({
            title: "Documento no encontrado",
            icon: "warning",
          });
        } else {
          this.populatePersonalData(response.data);
        }
      });
    },
    clearPersonalData: function () {
      this.user.name = "";
      this.user.address = "";
    },
    populatePersonalData: function (data) {
      if (this.user.dni.length === 8) {
        this.user.name = data.name;
        this.user.last_name = data.last_name;
      } else {
        this.user.name = data.razon_social;
        this.user.last_name = "";
      }
      this.user.address = data.direccion;
    },
    mtd_action: function () {
      let formData = new FormData();
      formData.append("id", this.user.id);
      formData.append("document", this.user.dni);
      formData.append("document_type", this.user.document_type);
      formData.append("name", this.user.name);
      formData.append("last_name", this.user.last_name);
      formData.append("company_id", this.user.company_id);
      formData.append("campu_id", this.user.campu_id);
      formData.append("email", this.user.email);
      formData.append("role_id", this.roleId);
      formData.append("state", this.user.state);

      this.post({
        url: `${this.$store.getters.get__url}/${this.prefix}/${this.modal.action}`,
        token: this.$store.getters.get__token,
        params: formData,
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({
              title: "Documento o Correo ya registrado",
              icon: "warning",
            });
          } else {
            const message =
              this.modal.action == "store"
                ? "REGISTRADO CORRECTAMENTE"
                : "EDITADO CORRECTAMENTE";
            const color = "success";
            if (this.modal.action == "store") {
              this.mtd_getdata();
            } else {
              this.data = this.data.map((element) =>
                element.Id === response.data[0].Id
                  ? { ...element, ...response.data[0] }
                  : element
              );
              this.componentKey += 1; // Forzar re-renderización
              this.mtd_getdata();
            }
            this.modal = { action: "", title: "", modal_form: false };
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = `NUEVO(A) ${this.roleName}`)
        : (this.modal.title = `EDITAR ${this.roleName}`);
      action == "store"
        ? (this.user = {
            id: "",
            dni: "",
            name: "",
            last_name: "",
            email: "",
            company_id: this.$store.getters.get_company.id,
            campu_id: "",
            job_position_id: "",
            state: "",
          })
        : (this.user = { ...this.user });
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.user = response;
        this.mtd_open_modal(true, "update");
      });
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          let temp = [];
          this.data.forEach((element) => {
            if (element.Id != response.id) {
              temp.push(element);
            }
          });
          this.data = temp;
          this.modal_delete = {
            boo: false,
            item: [],
          };
          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
          this.mtd_getdata();
        })
        .catch((errors) => {});
    },
    changeSwitch: function (payload) {
      this.user.state = payload == true ? 1 : 0;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (email == this.user.email) {
        if (!emailPattern.test(email)) {
          this.errors.email =
            "El correo electrónico no tiene un formato válido";
        } else {
          this.errors.email = "";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
